<template>
	<div ref="map" class="map-cont">
		<template v-if="loading">
			<v-progress-circular
				indeterminate
				color="primary"
				:size="30"
				width="2"
				class="ma-2"
			></v-progress-circular>
		</template>
		<template v-if="layersLoadingCounter">
			<v-progress-linear
				indeterminate
				color="primary"
				height="2"
				class="layer-loading-indicator"
			></v-progress-linear>
		</template>
		<MapPopup :map="map" v-if="map" />
		<MapTooltip ref="tooltip" />
	</div>
</template>

<script>
	import Map from "ol/Map";
	import MapHelper from "../../../components/helpers/MapHelper";
	import proj4 from "proj4";
	import View from "ol/View";
	import { register } from "ol/proj/proj4";
	import {transformExtent} from "ol/proj";
	import "ol/ol.css";
	import MapTooltip from "./MapTooltip";
	import cloneDeep from "lodash/cloneDeep";
	import TileLayer from "ol/layer/Tile";
	import MapPopup from "./MapPopup";

	export default {
		props: {
			content: Object,
			setActiveWhenLoaded: Boolean,
			myCardRow: Number
		},
		data: function(){
			var data = {
				loading: true,
				layersLoadingCounter: 0,
				map: null
			};
			return data;
		},
		components: {
			MapTooltip,
			MapPopup
		},
		computed: {
			myContent: {
				get: function(){
					return this.content;
				}
			}
		},
		mounted(){
			this.uniqueKey = 0;
			proj4.defs("EPSG:3346", "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
			register(proj4);
			var mapViewConfig = {
				projection: MapHelper.getProjection(),
				resolutions: MapHelper.getResolutions(),
				enableRotation: false,
				constrainResolution: true,
				smoothResolutionConstraint: false,
				zoomFactor: 8
			};
			if (this.myContent.mapConfig) {
				Object.assign(mapViewConfig, this.myContent.mapConfig);
			}
			this.map = new Map({
				target: this.$refs.map,
				view: this.refMapView || new View(mapViewConfig)
			});
			this.map.getLayers().on("add", function(e){
				var source;
				if (e.element instanceof TileLayer) {
					source = e.element.getSource();
					source.on("tileloadstart", function(){
						this.layersLoadingCounter += 1;
					}.bind(this));
					source.on("tileloadend", function(){
						this.layersLoadingCounter -= 1;
					}.bind(this));
					source.on("tileloaderror", function(){
						this.layersLoadingCounter -= 1;
					}.bind(this));
				} else {
					if (e.element.service) {
						source = e.element.getSource();
						source.on("imageloadstart", function(){
							// console.log("IS"); // Testavimui, jei kažkas susigrybauja...
							this.layersLoadingCounter += 1;
						}.bind(this));
						source.on("imageloadend", function(){
							// console.log("IE 1"); // Testavimui, jei kažkas susigrybauja...
							this.layersLoadingCounter -= 1;
						}.bind(this));
						source.on("imageloaderror", function(){
							// console.log("IE 2"); // Testavimui, jei kažkas susigrybauja...
							this.layersLoadingCounter -= 1;
						}.bind(this));
					}
				}
			}.bind(this));
			this.map.once("postrender", function(){
				if (this.myContent.mapConfig && this.myContent.mapConfig.layers) {
					// ...
				} else {
					this.addLayer(MapHelper.getBaseService());
				}
				if (this.myContent) {
					setTimeout(function(){
						if (this.map) {
							this.$set(this.myContent, "myMap", this); // 100 % nežinau, ar taip daryti yra teisinga... FIXME
							this.$vBus.$emit("map-added", this.map); // Reikalingas tik sinchronizavimo sekimui
							if (this.setActiveWhenLoaded) {
								this.$store.commit("setActiveWidget", {
									content: {
										type: "map",
										data: this.myContent
									}
								});
							}
						}
					}.bind(this), this.$store.state.testDelay);
				}
				if (this.myContent.mapConfig) {
					if (this.myContent.mapConfig.layers) {
						var layersLoaded = 0,
							totalLayersLength = this.myContent.mapConfig.layers.length;
						this.myContent.mapConfig.layers.forEach(function(service){
							if (service.base) {
								Object.assign(service, MapHelper.getBaseService());
							}
							if (this.myContent.mapConfig && this.myContent.mapConfig.identifyPoint) {
								service.callback = function(){
									layersLoaded += 1;
									if (layersLoaded == totalLayersLength) {
										// BIG FIXME! O gal reikėjo saugoti identifikavimo rezultatus ir juos vaizduoti??... Pvz. dabar gan sudėtinga pateikti tą patį rezultatą, kuris buvo matomas išsaugojant... Pvz. 3-ias item'as iš 7... O jei jo nebeliko servise? O jei būtent tas servisas nepasiekiamas?..
										this.doIdentify({
											coordinate: this.myContent.mapConfig.identifyPoint
										});
									}
								}.bind(this);
							}
							this.addLayer(service);
						}.bind(this));
					}
					if (this.myContent.mapConfig.noLegendInPreview) {
						this.noLegendInPreview = this.myContent.mapConfig.noLegendInPreview;
					}
				}
				this.map.on("click", function(e){
					if (!this.identifySuspended) {
						this.doIdentify(e);
					}
				}.bind(this));
				this.loading = false;
			}.bind(this));
			if (!this.myContent.mapConfig && !this.refMapView) {
				this.map.getView().fit(this.getFullExtent(), this.map.getSize());
			}
			this.$vBus.$on("update-in-row", this.updateSize);
		},
		beforeDestroy: function(){
			this.$vBus.$emit("map-removed", this.map); // Reikalingas tik sinchronizavimo sekimui
			this.$vBus.$off("update-in-row", this.updateSize);
		},
		methods: {
			addLayer: function(service){
				this.layersLoadingCounter += 1;
				if (!service.uniqueKey) {
					service.uniqueKey = this.getUniqueKey();
				}
				MapHelper.getLayer(service, "gisc", this.getFullExtent()).then(function(layer){
					var status;
					if (layer) {
						if (this.map) {
							layer.setZIndex(service.uniqueKey);
							if (typeof service.visible !== "undefined") {
								layer.set("visible", service.visible);
							}
							if (typeof service.opacity !== "undefined") {
								layer.set("opacity", service.opacity);
							}
							if (typeof service.layers !== "undefined") {
								layer.getSource().updateParams({
									"layers": service.layers
								});
							}
							this.map.addLayer(layer);
							status = true;
						}
					} else {
						console.warn("No layer", service);
					}
					if (service.callback) {
						service.callback(status);
					}
					this.layersLoadingCounter -= 1;
				}.bind(this), function(){
					if (service.callback) {
						service.callback(false);
					}
					console.warn("Layer retrieval failed", service);
					this.layersLoadingCounter -= 1;
				}.bind(this));
			},
			getFullExtent: function(){
				var extent = [21.0700, 53.9200, 26.8200, 56.4800];
				extent = transformExtent(extent, "EPSG:4326", this.map.getView().getProjection().getCode());
				return extent;
			},
			updateSize: function(row){
				if (this.map && (row == this.myCardRow)) {
					this.map.updateSize();
				}
			},
			getLayers: function(reverse){
				var layers = [],
					layersDict = {},
					zIndices = [],
					zIndex;
				if (this.map) {
					this.map.getLayers().forEach(function(layer){
						if (layer.service) {
							zIndex = layer.getZIndex();
							if (layersDict[zIndex]) {
								console.warn("LAYER order algorithm failed!");
							}
							layersDict[zIndex] = layer;
							zIndices.push(zIndex);
						}
					});
				}
				function sortNumber(a, b) {
					return a - b;
				}
				zIndices.sort(sortNumber);
				zIndices.forEach(function(zIndex){
					layers.push(layersDict[zIndex]);
				});
				if (reverse) {
					layers.reverse();
				}
				return layers;
			},
			getUniqueKey: function(){
				this.uniqueKey += 1;
				return this.uniqueKey;
			},
			doIdentify: function(e){
				var layers = []
				if (this.map) {
					this.map.getLayers(true).forEach(function(layer){
						if (layer.service && layer.getVisible()) {
							var identifyEnabled = true;
							if (typeof layer.service.identifyEnabled !== "undefined") {
								identifyEnabled = layer.service.identifyEnabled;
							}
							if (identifyEnabled) {
								layers.push(layer);
							}
						}
					});
				}
				if (layers.length) {
					e = {
						coordinates: e.coordinate,
						layers: layers
					}
					this.$vBus.$emit("do-identify", e, this.map);
				} else {
					this.$vBus.$emit("do-identify", this.map);
				}
			}
		},
		destroyed: function(){
			this.map = null;
		},
		watch: {
			"$store.state.refMapView": {
				immediate: true,
				handler: function(refMapView){
					this.refMapView = refMapView;
					if (this.map) {
						if (refMapView) {
							this.map.setView(refMapView);
						} else {
							var view = cloneDeep(this.map.getView());
							this.map.setView(view);
						}
					}
				}
			}
		}
	}
</script>

<style scoped>
	.map-cont {
		width: 100%;
		height: 100%;
		overflow: hidden; /* Be šito IE lygtais akimirkai pasirodo vertikalus scrollbar'as? */
	}
	.layer-loading-indicator {
		position: absolute;
		z-index: 1;
	}
</style>